// extracted by mini-css-extract-plugin
export default {"title":"giPTkBFX8FDkTVUVkGEIXw==","container":"HBYIqM5weCXfSw8Q6Ml2cA==","center":"Q5y8Z+AjbmZ2lGLjqn8WHg=="};